module.exports = __webpack_public_path__ + "static/img/company.44e68fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/company.png
// module id = Y8P+
// module chunks = 2